module.exports = __webpack_public_path__ + "bccc27396e887eabfc4a8dc3209544b4.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/NU.svg
// module id = /iFO
// module chunks = 0